export var MapTileType;
(function (MapTileType) {
    MapTileType[MapTileType["Vector"] = 0] = "Vector";
    MapTileType[MapTileType["Raster"] = 1] = "Raster";
})(MapTileType || (MapTileType = {}));
export var mapTileTypeMap = new Map([
    [MapTileType.Vector, 'vector'],
    [MapTileType.Raster, 'raster'],
]);
